import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, vModelText as _vModelText, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex-shrink-0 px-6 py-4 bg-slate-50 border-b border-slate-200"
};
const _hoisted_4 = {
  class: "flex items-center justify-between max-w-4xl mx-auto"
};
const _hoisted_5 = {
  class: "flex items-center"
};
const _hoisted_6 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "flex-1 overflow-y-auto min-h-0"
};
const _hoisted_9 = {
  class: "p-6"
};
const _hoisted_10 = {
  class: "max-w-2xl mx-auto"
};
const _hoisted_11 = {
  class: "space-y-5"
};
const _hoisted_12 = {
  class: "flex flex-wrap gap-2 mb-2"
};
const _hoisted_13 = ["value"];
const _hoisted_14 = {
  class: "text-sm"
};
const _hoisted_15 = {
  key: 0,
  class: "w-4 h-4 text-primary-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_16 = ["value"];
const _hoisted_17 = {
  class: "p-6"
};
const _hoisted_18 = {
  class: "max-w-4xl mx-auto"
};
const _hoisted_19 = {
  class: "space-y-4"
};
const _hoisted_20 = {
  class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_21 = {
  class: "flex items-center gap-3"
};
const _hoisted_22 = {
  class: "font-medium text-slate-900"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "p-4"
};
const _hoisted_25 = {
  class: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-4"
};
const _hoisted_26 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"
};
const _hoisted_27 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"
};
const _hoisted_28 = {
  class: "relative"
};
const _hoisted_29 = ["onUpdate:modelValue"];
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = ["onUpdate:modelValue", "onInput"];
const _hoisted_32 = {
  class: "mb-4"
};
const _hoisted_33 = ["onUpdate:modelValue"];
const _hoisted_34 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_35 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_36 = {
  class: "flex gap-2"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_40 = ["onUpdate:modelValue"];
const _hoisted_41 = {
  class: "relative flex-[1.4] min-w-[180px]"
};
const _hoisted_42 = ["onUpdate:modelValue", "onInput"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  key: 1,
  class: "text-center py-4 text-slate-500 text-sm bg-slate-50 rounded-lg"
};
const _hoisted_45 = {
  class: "mt-3 flex items-center justify-end gap-4"
};
const _hoisted_46 = {
  key: 0,
  class: "text-xs text-red-600"
};
const _hoisted_47 = {
  key: 2,
  class: "mt-4 border-t border-slate-200 pt-4"
};
const _hoisted_48 = {
  class: "flex items-center gap-3 mb-3"
};
const _hoisted_49 = {
  class: "text-sm font-medium text-slate-700"
};
const _hoisted_50 = {
  class: "bg-slate-50 rounded-xl p-4 flex items-center justify-between"
};
const _hoisted_51 = {
  class: "text-sm text-slate-600"
};
const _hoisted_52 = {
  class: "font-medium text-slate-900"
};
const _hoisted_53 = {
  class: "flex items-center gap-2"
};
const _hoisted_54 = {
  class: "text-xl font-bold text-primary-600"
};
const _hoisted_55 = {
  class: "p-6"
};
const _hoisted_56 = {
  class: "max-w-4xl mx-auto"
};
const _hoisted_57 = {
  class: "mb-8"
};
const _hoisted_58 = {
  class: "space-y-4 mb-4"
};
const _hoisted_59 = {
  class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_60 = {
  class: "flex items-center gap-3"
};
const _hoisted_61 = {
  class: "font-medium text-slate-900"
};
const _hoisted_62 = {
  key: 0,
  class: "px-2 py-0.5 bg-slate-200 text-slate-500 rounded text-xs font-medium"
};
const _hoisted_63 = {
  class: "flex items-center gap-2"
};
const _hoisted_64 = {
  class: "flex items-center gap-2"
};
const _hoisted_65 = {
  class: "form-switch"
};
const _hoisted_66 = ["checked", "onChange"];
const _hoisted_67 = ["onClick"];
const _hoisted_68 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"
};
const _hoisted_69 = ["onUpdate:modelValue", "disabled"];
const _hoisted_70 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_71 = {
  class: "flex items-center gap-3 mb-3"
};
const _hoisted_72 = ["checked", "disabled", "onChange"];
const _hoisted_73 = {
  key: 0,
  class: "pl-12"
};
const _hoisted_74 = {
  class: "flex items-center gap-6"
};
const _hoisted_75 = {
  class: "flex items-center gap-3"
};
const _hoisted_76 = {
  class: "flex items-center gap-2"
};
const _hoisted_77 = ["onUpdate:modelValue", "disabled"];
const _hoisted_78 = {
  class: "flex items-center gap-3"
};
const _hoisted_79 = ["onUpdate:modelValue", "disabled"];
const _hoisted_80 = {
  key: 0,
  class: "text-center py-8 text-slate-500"
};
const _hoisted_81 = {
  class: "mb-8"
};
const _hoisted_82 = {
  class: "mb-4 flex items-center justify-between"
};
const _hoisted_83 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_84 = {
  class: "form-switch"
};
const _hoisted_85 = ["checked"];
const _hoisted_86 = {
  key: 0,
  class: "border border-slate-200 rounded-xl overflow-hidden"
};
const _hoisted_87 = {
  class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_88 = {
  class: "flex items-center gap-3"
};
const _hoisted_89 = {
  key: 0,
  class: "px-2 py-0.5 bg-slate-200 text-slate-500 rounded text-xs font-medium"
};
const _hoisted_90 = {
  class: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-4"
};
const _hoisted_91 = {
  class: "flex items-center gap-2"
};
const _hoisted_92 = ["disabled"];
const _hoisted_93 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_94 = {
  class: "flex items-center gap-3 mb-3"
};
const _hoisted_95 = ["checked", "disabled"];
const _hoisted_96 = {
  key: 0,
  class: "pl-12"
};
const _hoisted_97 = {
  class: "flex items-center gap-6"
};
const _hoisted_98 = {
  class: "flex items-center gap-3"
};
const _hoisted_99 = {
  class: "flex items-center gap-2"
};
const _hoisted_100 = ["disabled"];
const _hoisted_101 = {
  class: "flex items-center gap-3"
};
const _hoisted_102 = ["disabled"];
const _hoisted_103 = {
  key: 1,
  class: "text-center py-8 text-slate-500 border border-dashed border-slate-300 rounded-xl"
};
const _hoisted_104 = {
  key: 0,
  class: "text-center py-8 text-slate-500 border border-dashed border-slate-300 rounded-xl"
};
const _hoisted_105 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_106 = {
  class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_107 = {
  class: "flex items-center gap-3"
};
const _hoisted_108 = {
  class: "font-medium text-slate-900"
};
const _hoisted_109 = {
  key: 0,
  class: "px-2 py-0.5 bg-slate-200 text-slate-500 rounded text-xs font-medium"
};
const _hoisted_110 = {
  key: 1,
  class: "px-2 py-0.5 bg-blue-100 text-blue-600 rounded text-xs font-medium"
};
const _hoisted_111 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_112 = {
  class: "form-switch"
};
const _hoisted_113 = ["checked", "onChange"];
const _hoisted_114 = ["onClick"];
const _hoisted_115 = ["onClick"];
const _hoisted_116 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"
};
const _hoisted_117 = {
  class: "flex items-center gap-2"
};
const _hoisted_118 = ["onUpdate:modelValue", "disabled"];
const _hoisted_119 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_120 = {
  class: "flex items-center gap-3 mb-3"
};
const _hoisted_121 = ["checked", "disabled", "onChange"];
const _hoisted_122 = {
  key: 0,
  class: "pl-12"
};
const _hoisted_123 = {
  class: "flex items-center gap-6"
};
const _hoisted_124 = {
  class: "flex items-center gap-3"
};
const _hoisted_125 = {
  class: "flex items-center gap-2"
};
const _hoisted_126 = ["onUpdate:modelValue", "disabled"];
const _hoisted_127 = {
  class: "flex items-center gap-3"
};
const _hoisted_128 = ["onUpdate:modelValue", "disabled"];
const _hoisted_129 = {
  class: "p-6"
};
const _hoisted_130 = {
  class: "max-w-3xl mx-auto"
};
const _hoisted_131 = {
  class: "bg-white border border-slate-200 rounded-xl overflow-hidden mb-4"
};
const _hoisted_132 = {
  class: "p-4"
};
const _hoisted_133 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_134 = {
  class: "font-medium text-slate-900"
};
const _hoisted_135 = {
  class: "font-medium text-slate-900"
};
const _hoisted_136 = {
  class: "col-span-2"
};
const _hoisted_137 = {
  class: "text-sm text-slate-600"
};
const _hoisted_138 = {
  class: "col-span-2"
};
const _hoisted_139 = {
  class: "text-sm text-slate-600"
};
const _hoisted_140 = {
  class: "bg-white border border-slate-200 rounded-xl overflow-hidden mb-4"
};
const _hoisted_141 = {
  class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_142 = {
  class: "text-sm text-slate-500"
};
const _hoisted_143 = {
  class: "divide-y divide-slate-200"
};
const _hoisted_144 = {
  class: "flex items-start justify-between mb-3"
};
const _hoisted_145 = {
  class: "flex items-center gap-2"
};
const _hoisted_146 = {
  class: "font-medium text-slate-900"
};
const _hoisted_147 = {
  class: "font-medium text-primary-600"
};
const _hoisted_148 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-2 text-sm"
};
const _hoisted_149 = {
  class: "text-slate-700"
};
const _hoisted_150 = {
  class: "text-slate-700"
};
const _hoisted_151 = {
  class: "text-slate-700"
};
const _hoisted_152 = {
  class: "text-slate-700"
};
const _hoisted_153 = {
  class: "bg-slate-50 px-4 py-3 border-t border-slate-200 flex items-center justify-end gap-4"
};
const _hoisted_154 = {
  class: "text-2xl font-bold text-primary-600"
};
const _hoisted_155 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex items-center justify-between bg-slate-50"
};
const _hoisted_156 = {
  key: 1
};
const _hoisted_157 = {
  class: "flex gap-3"
};
const _hoisted_158 = ["loading"];
const _hoisted_159 = ["loading"];
import { ref, reactive, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import FileUpload from '@/components/FileUpload.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
import ProductPicker from '@/components/ProductPicker.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import CustomerSelector from '@/components/CustomerSelector/index.vue';
import OrderServiceRemindersEditor from '@/components/OrderServiceRemindersEditor.vue';
import { getProductPage, getProductCategories } from '@/api/product';
import { savePlan, updatePlan, getPlanDetail, togglePlanReminderStatus, toggleBillingReminderStatus, toggleOrderRenewalReminderStatus, deletePlanReminder, deleteBillingReminder, deleteOrderRenewalReminder } from '@/api/plan';
import { calculateServiceEndByMonthlyPeriods } from '@/utils/servicePeriod';
export default {
  __name: 'ProposalFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 步骤相关
    const currentStep = ref(1);
    const saving = ref(false);
    const loadingOrders = ref(false);
    const attachmentUploading = ref(false);
    const selectedCustomerName = ref('');
    const productList = ref([]);
    const categories = ref([]);
    const wizardSteps = [{
      label: '基本信息',
      value: 1
    }, {
      label: '订单与账单',
      value: 2
    }, {
      label: '提醒设置',
      value: 3
    }, {
      label: '确认信息',
      value: 4
    }];

    // 表单数据
    let localKeySeed = 0;
    const createLocalKey = prefix => `${prefix}-${Date.now()}-${localKeySeed++}`;
    const createBillingReminderSetting = () => ({
      enabled: false,
      advanceDays: 0,
      remindTime: '09:30:00',
      repeatEnabled: false,
      repeatIntervalValue: 1,
      repeatIntervalUnit: 'HOUR',
      maxReminderCount: 10
    });
    const createRenewalReminderSetting = () => ({
      enabled: false,
      advanceDays: 0,
      remindTime: '09:30:00',
      repeatEnabled: false,
      repeatIntervalValue: 1,
      repeatIntervalUnit: 'HOUR',
      maxReminderCount: 10
    });
    const normalizeRepeatInterval = (totalMinutes = 60) => {
      if (totalMinutes >= 24 * 60 && totalMinutes % (24 * 60) === 0) {
        return {
          repeatIntervalValue: totalMinutes / (24 * 60),
          repeatIntervalUnit: 'DAY'
        };
      }
      if (totalMinutes >= 60 && totalMinutes % 60 === 0) {
        return {
          repeatIntervalValue: totalMinutes / 60,
          repeatIntervalUnit: 'HOUR'
        };
      }
      return {
        repeatIntervalValue: totalMinutes,
        repeatIntervalUnit: 'MINUTE'
      };
    };
    const toRepeatIntervalMinutes = (value, unit) => {
      const intervalValue = value || 1;
      if (unit === 'DAY') return intervalValue * 24 * 60;
      if (unit === 'HOUR') return intervalValue * 60;
      return intervalValue;
    };
    const normalizeLocalDateTime = value => {
      if (!value || typeof value !== 'string') return value || null;
      return value.includes(' ') ? value.replace(' ', 'T') : value;
    };
    const planForm = reactive({
      id: null,
      customerId: '',
      name: '',
      nameTags: [],
      nameOptions: ['财务财税', '融资', '项目申报', '股权方案', '资产'],
      detailContent: '',
      remark: '',
      attachments: [],
      orders: [],
      reminders: [],
      billingReminderSetting: createBillingReminderSetting()
    });

    // 计算属性
    const orderTotalAmount = computed(() => {
      return planForm.orders.reduce((sum, order) => sum + (order.amount || 0), 0);
    });

    // 是否编辑正式方案（不允许暂存草稿）
    const isEditingFormalPlan = computed(() => {
      return props.isEdit && props.editData?.isDraft !== 1;
    });

    // 需要设置订单服务提醒的订单（所选产品开启了"单独设置服务提醒"开关且用户选择「需要」）
    const serviceReminderOrders = computed(() => planForm.orders.filter(o => o.productNeedOrderReminder === 1 && o.serviceReminderRequired === 1));

    // 服务提醒逐单校验：选「需要」的订单必须至少一条启用提醒且内容完整；离开订单步骤（下一步）与正式提交时共用
    const validateServiceReminderOrders = () => {
      for (const order of serviceReminderOrders.value) {
        const enabledReminders = (order.serviceReminders || []).filter(r => r.enabled !== false);
        if (enabledReminders.length === 0) {
          ElMessage.warning(`服务产品【${order.productNameSnapshot || '未命名'}】要求至少设置一条服务提醒`);
          return false;
        }
        for (const reminder of enabledReminders) {
          if (!String(reminder.reminderItem || '').trim()) {
            ElMessage.warning('请填写服务提醒的提醒事项');
            return false;
          }
          if (!Array.isArray(reminder.receiverUserIds) || reminder.receiverUserIds.length === 0) {
            ElMessage.warning('请选择服务提醒的提醒人员');
            return false;
          }
          if (reminder.repeatType === 'INTERVAL') {
            if (!reminder.firstReminderTime) {
              ElMessage.warning('请设置服务提醒的首次提醒时间');
              return false;
            }
            if (!Number.isFinite(reminder.repeatIntervalValue) || reminder.repeatIntervalValue < 1) {
              ElMessage.warning('请设置服务提醒的提醒间隔');
              return false;
            }
          } else if (reminder.repeatType === 'WEEKLY') {
            if (!reminder.weekDay || !reminder.remindTime) {
              ElMessage.warning('请设置服务提醒的每周提醒时间');
              return false;
            }
          } else if (reminder.repeatType === 'MONTHLY') {
            if (!reminder.monthDay || !reminder.remindTime) {
              ElMessage.warning('请设置服务提醒的每月提醒时间');
              return false;
            }
          }
          if (reminder.endType === 'COUNT') {
            if (!Number.isFinite(reminder.maxReminderCount) || reminder.maxReminderCount < 1) {
              ElMessage.warning('请设置服务提醒的最大提醒次数');
              return false;
            }
          } else if (reminder.endType === 'SERVICE_END' && !order.serviceEnd) {
            ElMessage.warning('选择服务期结束时，请先在订单中填写服务结束日期');
            return false;
          }
        }
      }
      return true;
    };

    // CustomerSelector 确认回调，记录客户名称快照（用于确认步骤展示）
    const handleCustomerConfirm = customers => {
      const customer = Array.isArray(customers) ? customers[0] : customers;
      selectedCustomerName.value = customer?.name || '';
    };

    // 辅助函数：获取产品名称
    const getProductName = productId => {
      const product = productList.value.find(p => p.id === productId);
      return product ? `${product.name} (${product.code})` : '-';
    };

    // 辅助函数：获取执行人员名称
    const getExecutorName = order => {
      const executor = order.executor;
      return executor?.displayName || executor?.username || (order.executorId ? `用户${order.executorId}` : '-');
    };

    // 执行人员选择变化时，记录用户信息快照（用于确认步骤展示）
    const handleExecutorChange = (order, val) => {
      order.executorId = val;
      if (!val) {
        order.executor = null;
      }
    };

    // UserSelector 确认回调，保存用户信息快照
    const handleExecutorConfirm = (order, users) => {
      const user = Array.isArray(users) ? users[0] : users;
      if (user?.id) {
        order.executor = {
          id: user.id,
          username: user.username,
          displayName: user.name,
          phone: user.phone
        };
      }
    };

    // 方案名称多选处理
    watch(() => planForm.nameTags, tags => {
      planForm.name = tags.join('丨');
    });

    // 获取账单金额合计
    const getBillingTotal = order => {
      if (!order.billings || order.billings.length === 0) return 0;
      return order.billings.reduce((sum, b) => sum + (b.amount || 0), 0);
    };

    // 账单金额是否与订单金额一致
    const isBillingTotalValid = order => {
      return Math.abs(getBillingTotal(order) - (order.amount || 0)) < 0.01;
    };

    // 加载产品分类
    const loadCategories = async () => {
      try {
        const data = await getProductCategories();
        categories.value = data || [];
      } catch (error) {
        console.error('加载产品分类失败', error);
      }
    };

    // 加载产品列表
    const loadProducts = async (keyword = '') => {
      try {
        const data = await getProductPage({
          keyword: keyword || undefined,
          page: 1,
          size: 100
        });
        productList.value = data.records || [];
      } catch (error) {
        console.error('加载产品列表失败', error);
      }
    };

    // 产品选择变化
    const handleProductChange = (order, product) => {
      order.productSearchKeyword = '';
      order.amount = 0;
      order.executorId = null;
      order.executor = null;
      order._initialProduct = null;
      if (product) {
        // Keep productList updated for confirmation-step name lookups
        if (!productList.value.some(p => p.id === product.id)) {
          productList.value.push(product);
        }
        order.productNameSnapshot = `${product.name} (${product.code})`;
        order.productNeedOrderReminder = product.needOrderReminder ?? 0;
        // 提示语随产品快照到订单行；产品开关=1时默认选「是」，否则不需要该选择（提交时传null）
        order.orderReminderPrompt = product.orderReminderPrompt ?? '';
        order.serviceReminderRequired = order.productNeedOrderReminder === 1 ? 1 : null;
      } else {
        order.productNeedOrderReminder = 0;
        order.orderReminderPrompt = '';
        order.serviceReminderRequired = null;
      }
      if (order.productId) {
        // 切换产品时清空执行人员选择
        order.executorId = null;
        order.executor = null;
      }
    };

    // 向导步骤控制
    const nextStep = () => {
      if (currentStep.value === 1) {
        if (!planForm.name.trim()) {
          ElMessage.warning('请输入方案名称');
          return;
        }
        if (!planForm.customerId) {
          ElMessage.warning('请选择客户');
          return;
        }
      }
      if (currentStep.value === 2) {
        // 服务提醒选「需要」的订单：至少填写一条且内容完整后才允许进入下一步
        if (!validateServiceReminderOrders()) return;
      }
      if (currentStep.value < 4) {
        currentStep.value++;
      }
    };
    const prevStep = () => {
      if (currentStep.value > 1) {
        currentStep.value--;
      }
    };

    // 订单操作
    const addOrder = () => {
      const newOrder = {
        _localKey: createLocalKey('order'),
        id: null,
        productId: '',
        productSearchKeyword: '',
        orderType: 'ONCE',
        periodCount: null,
        serviceStart: '',
        serviceEnd: '',
        amount: 0,
        remark: '',
        executorId: null,
        executor: null,
        billings: [],
        renewalReminderSetting: createRenewalReminderSetting(),
        productNeedOrderReminder: 0,
        orderReminderPrompt: '',
        serviceReminderRequired: null,
        serviceReminders: []
      };
      planForm.orders.push(newOrder);
    };
    const removeOrder = index => {
      planForm.orders.splice(index, 1);
    };
    const handleOrderTypeChange = order => {
      if (order.orderType === 'ONCE') {
        order.periodCount = null;
      } else {
        order.periodCount = calculateNaturalMonthPeriods(order.serviceStart, order.serviceEnd) || order.periodCount || 1;
      }
      if (!order.renewalReminderSetting) {
        order.renewalReminderSetting = createRenewalReminderSetting();
      }
    };
    const calculateNaturalMonthPeriods = (startDate, endDate) => {
      if (!startDate || !endDate) return null;
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return null;
      return (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1;
    };
    const updatePeriodCountByServiceRange = order => {
      if (order.orderType !== 'PERIODIC') return;
      const periodCount = calculateNaturalMonthPeriods(order.serviceStart, order.serviceEnd);
      if (periodCount) {
        order.periodCount = periodCount;
      }
    };
    const updateServiceEndByPeriodCount = order => {
      if (order.orderType !== 'PERIODIC') return;
      const serviceEnd = calculateServiceEndByMonthlyPeriods(order.serviceStart, order.periodCount);
      if (serviceEnd) {
        order.serviceEnd = serviceEnd;
      }
    };

    // 账单操作
    const generateBillings = order => {
      if (order.amount === null || order.amount === undefined || order.amount === '') {
        ElMessage.warning('请先输入订单金额');
        return;
      }
      const periodCount = order.orderType === 'PERIODIC' ? order.periodCount || 1 : 1;
      const amountPerPeriod = order.amount / periodCount;
      const startDate = order.serviceStart ? new Date(order.serviceStart) : new Date();
      const bills = [];
      for (let i = 1; i <= periodCount; i++) {
        const dueDate = new Date(startDate);
        dueDate.setMonth(dueDate.getMonth() + (i - 1));
        const dueDateStr = dueDate.toISOString().split('T')[0];
        bills.push({
          periodIndex: i,
          amount: Number(amountPerPeriod.toFixed(2)),
          dueDate: dueDateStr
        });
      }
      order.billings = bills;
    };
    const addBilling = order => {
      if (!order.billings) order.billings = [];
      const maxPeriod = order.billings.reduce((max, b) => Math.max(max, b.periodIndex || 0), 0);
      order.billings.push({
        periodIndex: maxPeriod + 1,
        amount: 0,
        dueDate: ''
      });
    };

    // 账单金额变化时同步订单金额
    const syncOrderAmountFromBillings = order => {
      if (order.billings && order.billings.length > 0) {
        order.amount = getBillingTotal(order);
      }
    };
    const removeBilling = (order, index) => {
      order.billings.splice(index, 1);
      syncOrderAmountFromBillings(order);
    };

    // 提醒操作
    const addReminder = () => {
      planForm.reminders.push({
        _localKey: createLocalKey('reminder'),
        enabled: true,
        firstReminderTime: '',
        reminderItem: '',
        repeatEnabled: false,
        repeatIntervalValue: 1,
        repeatIntervalUnit: 'HOUR',
        maxReminderCount: 10
      });
    };
    const toggleReminder = async reminder => {
      // 计算新的开关状态：当前为false时切换为true，否则切换为false
      const newEnabled = reminder.enabled === false ? true : false;
      // 如果是已保存的提醒（有待切换ID），调用API
      if (reminder.id) {
        try {
          await togglePlanReminderStatus(reminder.id, newEnabled);
          reminder.enabled = newEnabled;
        } catch (error) {
          console.error('切换提醒状态失败', error);
        }
      } else {
        // 新增的提醒，直接切换本地状态
        reminder.enabled = newEnabled;
      }
    };

    // 切换方案账单提醒
    const toggleBillingReminder = async () => {
      const setting = planForm.billingReminderSetting;
      const newEnabled = !setting.enabled;
      // 如果是已保存的账单提醒（有ID），调用API
      if (setting.id) {
        try {
          await toggleBillingReminderStatus(planForm.id, newEnabled);
          setting.enabled = newEnabled;
        } catch (error) {
          console.error('切换账单提醒状态失败', error);
        }
      } else {
        // 新增的账单提醒，直接切换本地状态
        setting.enabled = newEnabled;
      }
    };

    // 切换订单续约提醒
    const toggleOrderRenewalReminder = async order => {
      if (!order.renewalReminderSetting) {
        order.renewalReminderSetting = createRenewalReminderSetting();
      }
      const newEnabled = !order.renewalReminderSetting.enabled;
      // 如果是已保存的续约提醒（有ID），调用API
      if (order.renewalReminderSetting.id) {
        try {
          await toggleOrderRenewalReminderStatus(order.id, newEnabled);
          order.renewalReminderSetting.enabled = newEnabled;
        } catch (error) {
          console.error('切换续约提醒状态失败', error);
        }
      } else {
        // 新增的续约提醒，直接切换本地状态
        order.renewalReminderSetting.enabled = newEnabled;
      }
    };

    // 删除方案跟进提醒
    const removeReminder = async index => {
      const reminder = planForm.reminders[index];
      if (!reminder) {
        planForm.reminders.splice(index, 1);
        return;
      }
      if (reminder.id) {
        try {
          await deletePlanReminder(reminder.id);
          planForm.reminders.splice(index, 1);
        } catch (error) {
          console.error('删除提醒失败', error);
        }
      } else {
        planForm.reminders.splice(index, 1);
      }
    };

    // 删除方案账单提醒
    const removeBillingReminder = async () => {
      const setting = planForm.billingReminderSetting;
      if (setting.id) {
        try {
          await deleteBillingReminder(planForm.id);
          planForm.billingReminderSetting = createBillingReminderSetting();
        } catch (error) {
          console.error('删除账单提醒失败', error);
        }
      } else {
        planForm.billingReminderSetting = createBillingReminderSetting();
      }
    };

    // 删除订单续约提醒
    const removeOrderRenewalReminder = async order => {
      if (!order.renewalReminderSetting) return;
      if (order.renewalReminderSetting.id) {
        try {
          await deleteOrderRenewalReminder(order.id);
          order.renewalReminderSetting = createRenewalReminderSetting();
        } catch (error) {
          console.error('删除续约提醒失败', error);
        }
      } else {
        order.renewalReminderSetting = createRenewalReminderSetting();
      }
    };

    // 添加订单续约提醒
    const addOrderRenewalReminder = order => {
      order.renewalReminderSetting = {
        ...createRenewalReminderSetting(),
        _added: true
      };
    };

    // 添加账单提醒
    const addBillingReminder = () => {
      planForm.billingReminderSetting = {
        ...createBillingReminderSetting(),
        _added: true
      };
    };

    // 表单验证（只验证基本信息，不验证订单）
    const validateForm = () => {
      if (!planForm.name.trim()) {
        ElMessage.warning('请输入方案名称');
        return false;
      }
      if (!planForm.customerId) {
        ElMessage.warning('请选择客户');
        return false;
      }
      return true;
    };
    const validateReminderSettings = isDraft => {
      for (let i = 0; i < planForm.reminders.length; i++) {
        const reminder = planForm.reminders[i];
        if (reminder.enabled === false) continue;
        if (!reminder.firstReminderTime) {
          ElMessage.warning(`请完善提醒${i + 1}的首次提醒时间`);
          return false;
        }
        if (!String(reminder.reminderItem || '').trim()) {
          ElMessage.warning(`请完善提醒${i + 1}的提醒事项`);
          return false;
        }
        if (reminder.repeatEnabled) {
          if (!Number.isFinite(reminder.repeatIntervalValue) || reminder.repeatIntervalValue < 1) {
            ElMessage.warning(`请设置提醒${i + 1}的连续提醒间隔`);
            return false;
          }
          if (!Number.isFinite(reminder.maxReminderCount) || reminder.maxReminderCount < 1) {
            ElMessage.warning(`请设置提醒${i + 1}的最大提醒次数`);
            return false;
          }
        }
      }
      const billingReminder = planForm.billingReminderSetting;
      if (billingReminder?.enabled) {
        if (!Number.isFinite(billingReminder.advanceDays) || billingReminder.advanceDays < 0) {
          ElMessage.warning('请设置正确的账单提醒提前天数');
          return false;
        }
        if (!billingReminder.remindTime) {
          ElMessage.warning('请设置账单提醒时间');
          return false;
        }
        if (billingReminder.repeatEnabled) {
          if (!Number.isFinite(billingReminder.repeatIntervalValue) || billingReminder.repeatIntervalValue < 1) {
            ElMessage.warning('请设置正确的账单连续提醒间隔');
            return false;
          }
          if (!Number.isFinite(billingReminder.maxReminderCount) || billingReminder.maxReminderCount < 1) {
            ElMessage.warning('请设置正确的账单最大提醒次数');
            return false;
          }
        }
      }
      for (let i = 0; i < planForm.orders.length; i++) {
        const order = planForm.orders[i];
        if (!order.renewalReminderSetting?.enabled) continue;
        if (!Number.isFinite(order.renewalReminderSetting.advanceDays) || order.renewalReminderSetting.advanceDays < 0) {
          ElMessage.warning(`请设置订单${i + 1}正确的续约提醒提前天数`);
          return false;
        }
        if (!order.renewalReminderSetting.remindTime) {
          ElMessage.warning(`请设置订单${i + 1}的续约提醒时间`);
          return false;
        }
        if (order.renewalReminderSetting.repeatEnabled) {
          if (!Number.isFinite(order.renewalReminderSetting.repeatIntervalValue) || order.renewalReminderSetting.repeatIntervalValue < 1) {
            ElMessage.warning(`请设置订单${i + 1}正确的续约连续提醒间隔`);
            return false;
          }
          if (!Number.isFinite(order.renewalReminderSetting.maxReminderCount) || order.renewalReminderSetting.maxReminderCount < 1) {
            ElMessage.warning(`请设置订单${i + 1}正确的续约最大提醒次数`);
            return false;
          }
        }
      }

      // 订单服务提醒必填校验（草稿保存时跳过；与离开订单步骤的校验共用同一函数）
      if (!isDraft) {
        if (!validateServiceReminderOrders()) return false;
      }
      return true;
    };

    // 检查是否存在金额为0的订单或账单
    const hasZeroAmountOrdersOrBillings = () => {
      for (const order of planForm.orders) {
        if (order.amount === 0) {
          return true;
        }
        if (order.billings?.some(b => b.amount === 0)) {
          return true;
        }
      }
      return false;
    };
    const normalizePlanAttachments = () => {
      return (planForm.attachments || []).map((file, index) => ({
        id: file.id || null,
        fileName: file.originalName || file.fileName || file.name || '附件',
        fileKey: file.fileKey || file.fileName || '',
        fileSize: file.fileSize ?? file.size ?? 0,
        fileType: file.fileType || file.contentType || '',
        bucket: file.bucket || 'private',
        sort: file.sort ?? index
      })).filter(file => file.fileKey);
    };
    const ensureAttachmentsReady = () => {
      if (attachmentUploading.value) {
        ElMessage.warning('附件上传中，请稍后提交');
        return false;
      }
      return true;
    };

    // 构建提交数据
    const buildPlanCommand = isDraft => {
      return {
        plan: {
          id: planForm.id || null,
          customerId: planForm.customerId,
          name: planForm.name,
          isDraft: isDraft,
          totalAmount: orderTotalAmount.value,
          payableAmount: orderTotalAmount.value,
          remark: planForm.remark,
          detailContent: planForm.detailContent
        },
        orders: planForm.orders.map(o => ({
          id: o.id || null,
          productId: o.productId,
          orderType: o.orderType,
          periodCount: o.orderType === 'PERIODIC' ? o.periodCount : undefined,
          serviceStart: o.serviceStart || undefined,
          serviceEnd: o.serviceEnd || undefined,
          amount: o.amount,
          remark: o.remark || undefined,
          executorId: o.executorId || undefined,
          billings: o.billings || [],
          renewalReminderSetting: o.renewalReminderSetting?.enabled ? {
            id: o.renewalReminderSetting.id || null,
            enabled: true,
            advanceDays: o.renewalReminderSetting.advanceDays || 0,
            remindTime: o.renewalReminderSetting.remindTime || '09:30:00',
            repeatEnabled: o.renewalReminderSetting.repeatEnabled || false,
            repeatIntervalMinutes: o.renewalReminderSetting.repeatEnabled ? toRepeatIntervalMinutes(o.renewalReminderSetting.repeatIntervalValue, o.renewalReminderSetting.repeatIntervalUnit) : null,
            maxReminderCount: o.renewalReminderSetting.repeatEnabled ? o.renewalReminderSetting.maxReminderCount || 10 : null
          } : null,
          // 订单级服务提醒选择：产品开关=0的行传null；选「否」的行显式传空数组清空存量
          serviceReminderRequired: o.productNeedOrderReminder === 1 ? o.serviceReminderRequired : null,
          // 订单服务提醒：全量携带（后端按订单全删重建，漏带即丢失）
          serviceReminders: o.serviceReminderRequired === 0 ? [] : (o.serviceReminders || []).map(r => ({
            reminderItem: r.reminderItem || '',
            repeatType: r.repeatType,
            firstReminderTime: r.repeatType === 'INTERVAL' ? normalizeLocalDateTime(r.firstReminderTime) || undefined : undefined,
            repeatIntervalMinutes: r.repeatType === 'INTERVAL' ? toRepeatIntervalMinutes(r.repeatIntervalValue, r.repeatIntervalUnit) : undefined,
            weekDay: r.repeatType === 'WEEKLY' ? r.weekDay : undefined,
            monthDay: r.repeatType === 'MONTHLY' ? r.monthDay : undefined,
            remindTime: r.repeatType === 'INTERVAL' ? undefined : r.remindTime || undefined,
            endType: r.endType,
            maxReminderCount: r.endType === 'COUNT' ? r.maxReminderCount || 10 : undefined,
            receiverUserIds: (r.receiverUserIds || []).map(Number),
            enabled: r.enabled !== false
          }))
        })),
        reminders: planForm.reminders.map(r => {
          const repeatIntervalMinutes = r.repeatEnabled ? toRepeatIntervalMinutes(r.repeatIntervalValue, r.repeatIntervalUnit) : null;
          return {
            id: r.id || null,
            firstReminderTime: normalizeLocalDateTime(r.firstReminderTime),
            reminderItem: r.reminderItem || '',
            repeatEnabled: r.repeatEnabled || false,
            repeatIntervalMinutes,
            maxReminderCount: r.repeatEnabled ? r.maxReminderCount || 10 : null,
            enabled: r.enabled !== false
          };
        }),
        attachments: normalizePlanAttachments(),
        billingReminderSetting: planForm.billingReminderSetting?.enabled ? {
          id: planForm.billingReminderSetting.id || null,
          enabled: true,
          advanceDays: planForm.billingReminderSetting.advanceDays || 0,
          remindTime: planForm.billingReminderSetting.remindTime || '09:30:00',
          repeatEnabled: planForm.billingReminderSetting.repeatEnabled || false,
          repeatIntervalMinutes: planForm.billingReminderSetting.repeatEnabled ? toRepeatIntervalMinutes(planForm.billingReminderSetting.repeatIntervalValue, planForm.billingReminderSetting.repeatIntervalUnit) : null,
          maxReminderCount: planForm.billingReminderSetting.repeatEnabled ? planForm.billingReminderSetting.maxReminderCount || 10 : null
        } : null,
        asDraft: isDraft === 1
      };
    };

    // 保存和提交操作
    const handleSaveDraft = async () => {
      if (!validateForm()) return;
      if (!validateReminderSettings(true)) return;
      if (!ensureAttachmentsReady()) return;

      // 检查是否存在金额为0的订单或账单
      if (hasZeroAmountOrdersOrBillings()) {
        try {
          await ElMessageBox.confirm('订单或账单中存在金额为0的条目，确认要保存吗？', '金额确认', {
            confirmButtonText: '确认保存',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } catch {
          return; // 用户取消
        }
      }
      saving.value = true;
      try {
        const command = buildPlanCommand(1);
        if (props.isEdit) {
          await updatePlan(command);
        } else {
          await savePlan(command);
        }
        ElMessage.success('保存成功');
        closeModal();
        emit('success');
      } catch (error) {
        ElMessage.error(error.message || '保存失败');
      } finally {
        saving.value = false;
      }
    };
    const handleSubmit = async () => {
      if (!validateForm()) return;
      if (!validateReminderSettings(false)) return;
      if (!ensureAttachmentsReady()) return;

      // 检查是否存在金额为0的订单或账单
      if (hasZeroAmountOrdersOrBillings()) {
        try {
          await ElMessageBox.confirm('订单或账单中存在金额为0的条目，确认要提交吗？', '金额确认', {
            confirmButtonText: '确认提交',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } catch {
          return; // 用户取消
        }
      }
      saving.value = true;
      try {
        const command = buildPlanCommand(0);
        const result = await updatePlan(command);
        if (result?.needApproval) {
          ElMessage.success('提交成功，方案已进入审批流程');
        } else {
          ElMessage.success('提交成功');
        }
        closeModal();
        emit('success');
      } catch (error) {
        ElMessage.error(error.message || '提交失败');
      } finally {
        saving.value = false;
      }
    };

    // 关闭弹窗
    const closeModal = () => {
      emit('update:visible', false);
    };

    // 初始化表单数据
    const initForm = async () => {
      currentStep.value = 1;
      if (props.isEdit && props.editData) {
        // 编辑模式：回填方案基本信息
        const nameTags = props.editData.name ? props.editData.name.split('丨') : [];
        Object.assign(planForm, {
          id: props.editData.id,
          customerId: props.editData.customerId,
          name: props.editData.name,
          nameTags: nameTags,
          nameOptions: ['财务财税', '融资', '项目申报', '股权方案', '资产'],
          detailContent: props.editData.detailContent || '',
          remark: props.editData.remark || '',
          attachments: [],
          orders: [],
          reminders: [],
          billingReminderSetting: createBillingReminderSetting()
        });
        selectedCustomerName.value = props.editData.customerName || '';

        // 加载方案详情以获取订单数据
        loadingOrders.value = true;
        try {
          const detail = await getPlanDetail(props.editData.id);
          // 回填方案详情内容
          planForm.detailContent = detail.detailContent || '';
          planForm.attachments = detail.attachments || [];
          if (detail?.orders?.length) {
            planForm.orders = detail.orders.map(order => ({
              _localKey: createLocalKey('order'),
              id: order.id,
              productId: order.productId,
              _initialProduct: order.productNameSnapshot ? {
                id: order.productId,
                name: order.productNameSnapshot,
                code: order.productCodeSnapshot || ''
              } : null,
              productSearchKeyword: '',
              orderType: order.orderType,
              periodCount: order.periodCount,
              serviceStart: order.serviceStart || '',
              serviceEnd: order.serviceEnd || '',
              amount: order.amount || 0,
              remark: order.remark || '',
              executorId: order.executorId,
              executor: order.executor ? {
                id: order.executor.id,
                username: order.executor.username,
                displayName: order.executor.displayName,
                phone: order.executor.phone
              } : null,
              renewalReminderSetting: createRenewalReminderSetting(),
              productNeedOrderReminder: order.needOrderReminder ?? 0,
              orderReminderPrompt: order.orderReminderPrompt ?? '',
              // NULL 历史数据按「是」回显，维持旧的强制语义
              serviceReminderRequired: order.serviceReminderRequired ?? 1,
              serviceReminders: (order.serviceReminders || []).map(r => {
                const {
                  repeatIntervalValue,
                  repeatIntervalUnit
                } = normalizeRepeatInterval(r.repeatIntervalMinutes || 60);
                return {
                  _localKey: createLocalKey('serviceReminder'),
                  id: r.id,
                  enabled: r.enabled,
                  reminderItem: r.reminderItem || '',
                  receiverUserIds: r.receiverUserIds || [],
                  repeatType: r.repeatType || 'WEEKLY',
                  firstReminderTime: normalizeLocalDateTime(r.firstReminderTime) || '',
                  repeatIntervalValue,
                  repeatIntervalUnit,
                  weekDay: r.weekDay ?? 1,
                  monthDay: r.monthDay ?? 1,
                  remindTime: r.remindTime || '09:30:00',
                  endType: r.endType || 'COUNT',
                  maxReminderCount: r.maxReminderCount || 10
                };
              }),
              billings: (order.billings || []).map(b => ({
                id: b.id,
                periodIndex: b.periodIndex,
                amount: b.amount || 0,
                dueDate: b.dueDate || ''
              }))
            }));
          }

          // 回填提醒数据
          if (detail?.reminders?.length) {
            planForm.reminders = detail.reminders.map(r => {
              // 将分钟转换为值和单位
              const {
                repeatIntervalValue,
                repeatIntervalUnit
              } = normalizeRepeatInterval(r.repeatIntervalMinutes || 60);
              return {
                _localKey: createLocalKey('reminder'),
                id: r.id,
                firstReminderTime: normalizeLocalDateTime(r.firstReminderTime) || '',
                reminderItem: r.reminderItem || '',
                repeatEnabled: r.repeatEnabled || false,
                repeatIntervalValue,
                repeatIntervalUnit,
                maxReminderCount: r.maxReminderCount || 10,
                enabled: r.enabled
              };
            });
          }

          // 回填方案账单提醒设置
          if (detail?.billingReminderSetting) {
            const {
              repeatIntervalValue,
              repeatIntervalUnit
            } = normalizeRepeatInterval(detail.billingReminderSetting.repeatIntervalMinutes || 60);
            planForm.billingReminderSetting = {
              ...createBillingReminderSetting(),
              id: detail.billingReminderSetting.id,
              enabled: detail.billingReminderSetting.enabled,
              advanceDays: detail.billingReminderSetting.advanceDays || 0,
              remindTime: detail.billingReminderSetting.remindTime || '09:30:00',
              repeatEnabled: detail.billingReminderSetting.repeatEnabled || false,
              repeatIntervalValue,
              repeatIntervalUnit,
              maxReminderCount: detail.billingReminderSetting.maxReminderCount || 10
            };
          }

          // 回填订单续约提醒设置
          if (detail?.orders?.length) {
            detail.orders.forEach((orderDetail, index) => {
              if (planForm.orders[index] && orderDetail.renewalReminderSetting) {
                const {
                  repeatIntervalValue,
                  repeatIntervalUnit
                } = normalizeRepeatInterval(orderDetail.renewalReminderSetting.repeatIntervalMinutes || 60);
                planForm.orders[index].renewalReminderSetting = {
                  ...createRenewalReminderSetting(),
                  id: orderDetail.renewalReminderSetting.id,
                  enabled: orderDetail.renewalReminderSetting.enabled,
                  advanceDays: orderDetail.renewalReminderSetting.advanceDays || 0,
                  remindTime: orderDetail.renewalReminderSetting.remindTime || '09:30:00',
                  repeatEnabled: orderDetail.renewalReminderSetting.repeatEnabled || false,
                  repeatIntervalValue,
                  repeatIntervalUnit,
                  maxReminderCount: orderDetail.renewalReminderSetting.maxReminderCount || 10
                };
              }
            });
          }
        } catch (error) {
          console.error('加载方案详情失败', error);
        } finally {
          loadingOrders.value = false;
        }
      } else {
        // 新建模式下，如果传入了 editData 中的客户信息，则默认选中该客户
        const defaultCustomerId = props.editData?.customerId || '';
        const defaultCustomerName = props.editData?.customerName || '';
        Object.assign(planForm, {
          id: null,
          customerId: defaultCustomerId,
          name: '',
          nameTags: [],
          nameOptions: ['财务财税', '融资', '项目申报', '股权方案', '资产'],
          detailContent: '',
          remark: '',
          attachments: [],
          orders: [],
          reminders: [],
          billingReminderSetting: createBillingReminderSetting()
        });

        // 如果有默认客户，记录名称快照以便确认步骤展示
        selectedCustomerName.value = defaultCustomerName;
      }
    };

    // 监听 visible 变化
    watch(() => props.visible, async val => {
      if (val) {
        await initForm();
        loadProducts();
        loadCategories();
      }
    }, {
      immediate: true
    });
    loadProducts();
    loadCategories();
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_time_picker = _resolveComponent("el-time-picker");
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createBlock(AppModal, {
        visible: __props.visible,
        size: "5xl",
        onClose: closeModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.isEdit ? '编辑方案' : '新建方案'), 1), _cache[12] || (_cache[12] = _createElementVNode("p", {
          class: "text-sm text-slate-500 mt-0.5"
        }, "请按照以下步骤完成方案信息填写", -1))]), _createElementVNode("button", {
          onClick: closeModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(wizardSteps, (step, index) => {
          return _createElementVNode("div", {
            key: step.value,
            class: "flex items-center"
          }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
            class: _normalizeClass(['w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-300', currentStep.value > step.value ? 'bg-green-500 text-white' : currentStep.value === step.value ? 'bg-primary-600 text-white' : 'bg-slate-200 text-slate-500'])
          }, [currentStep.value > step.value ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[14] || (_cache[14] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          }, null, -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(index + 1), 1))], 2), _createElementVNode("span", {
            class: _normalizeClass(['ml-2 text-sm font-medium transition-colors whitespace-nowrap', currentStep.value >= step.value ? 'text-slate-900' : 'text-slate-400'])
          }, _toDisplayString(step.label), 3)]), index < wizardSteps.length - 1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['flex-1 h-0.5 mx-4 transition-colors duration-300', currentStep.value > step.value ? 'bg-green-500' : 'bg-slate-200'])
          }, null, 2)) : _createCommentVNode("", true)]);
        }), 64))])]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "mb-6"
        }, [_createElementVNode("h4", {
          class: "text-base font-medium text-slate-900 mb-1"
        }, "方案基本信息"), _createElementVNode("p", {
          class: "text-sm text-slate-500"
        }, "填写方案的名称、客户以及详细说明信息")], -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 方案名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planForm.nameOptions, tag => {
          return _openBlock(), _createElementBlock("label", {
            key: tag,
            class: _normalizeClass(["flex items-center gap-1.5 px-3 py-1.5 border rounded-lg cursor-pointer transition-all duration-200", planForm.nameTags.includes(tag) ? 'border-primary-500 bg-primary-50 text-primary-700' : 'border-slate-300 hover:border-primary-300 hover:bg-primary-50'])
          }, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: tag,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => planForm.nameTags = $event),
            class: "sr-only"
          }, null, 8, _hoisted_13), [[_vModelCheckbox, planForm.nameTags]]), _createElementVNode("span", _hoisted_14, _toDisplayString(tag), 1), planForm.nameTags.includes(tag) ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[15] || (_cache[15] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          }, null, -1)]))])) : _createCommentVNode("", true)], 2);
        }), 128))]), _createElementVNode("input", {
          value: planForm.name,
          type: "text",
          readonly: "",
          class: "form-input form-readonly w-full",
          placeholder: "请勾选上方选项"
        }, null, 8, _hoisted_16)]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 客户 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(CustomerSelector, {
          modelValue: planForm.customerId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => planForm.customerId = $event),
          placeholder: "请选择客户",
          class: "w-full",
          onConfirm: handleCustomerConfirm
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[18] || (_cache[18] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "方案详情", -1)), _createVNode(RichTextEditor, {
          modelValue: planForm.detailContent,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => planForm.detailContent = $event),
          "upload-module": "plan",
          class: "mt-2"
        }, null, 8, ["modelValue"]), _cache[19] || (_cache[19] = _createElementVNode("p", {
          class: "mt-2 text-xs text-slate-500"
        }, "支持富文本格式，保存后将作为方案详情展示。", -1))]), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "方案附件", -1)), _createVNode(FileUpload, {
          files: planForm.attachments,
          "onUpdate:files": _cache[3] || (_cache[3] = $event => planForm.attachments = $event),
          module: "plan-attachment",
          bucket: "private",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.zip,.rar",
          "max-count": 10,
          "max-size": 20,
          onUploadingChange: _cache[4] || (_cache[4] = $event => attachmentUploading.value = $event)
        }, null, 8, ["files"]), _cache[21] || (_cache[21] = _createElementVNode("p", {
          class: "mt-2 text-xs text-slate-500"
        }, "附件非必填，最多10个，单个不超过20MB。", -1))]), _createElementVNode("div", null, [_cache[22] || (_cache[22] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => planForm.remark = $event),
          rows: "3",
          class: "form-textarea",
          placeholder: "请输入备注信息（可选）"
        }, null, 512), [[_vModelText, planForm.remark]])])])])], 512), [[_vShow, currentStep.value === 1]]), _withDirectives(_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[49] || (_cache[49] = _createElementVNode("div", {
          class: "mb-6"
        }, [_createElementVNode("h4", {
          class: "text-base font-medium text-slate-900 mb-1"
        }, "订单与账单信息"), _createElementVNode("p", {
          class: "text-sm text-slate-500"
        }, "添加订单信息，包括产品、类型、执行人员以及账单明细")], -1)), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planForm.orders, (order, orderIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: orderIndex,
            class: "border border-slate-200 rounded-xl overflow-hidden"
          }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[24] || (_cache[24] = _createElementVNode("div", {
            class: "w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          })])], -1)), _createElementVNode("span", _hoisted_22, "订单 " + _toDisplayString(orderIndex + 1), 1), _createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-medium', order.orderType === 'ONCE' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'])
          }, _toDisplayString(order.orderType === 'ONCE' ? '一次性服务' : '分期服务'), 3)]), _createElementVNode("button", {
            onClick: $event => removeOrder(orderIndex),
            class: "p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_23)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(ProductPicker, {
            modelValue: order.productId,
            "onUpdate:modelValue": $event => order.productId = $event,
            categories: categories.value,
            "initial-product": order._initialProduct,
            onChange: product => handleProductChange(order, product)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "categories", "initial-product", "onChange"]), _createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 订单类型 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: order.orderType,
            "onUpdate:modelValue": $event => order.orderType = $event,
            placeholder: "请选择类型",
            class: "w-full form-select",
            onChange: $event => handleOrderTypeChange(order)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "一次性服务",
              value: "ONCE"
            }), _createVNode(_component_el_option, {
              label: "分期服务",
              value: "PERIODIC"
            })]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]), _createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 落地执行人员 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(UserSelector, {
            modelValue: order.executorId,
            "onUpdate:modelValue": [$event => order.executorId = $event, val => handleExecutorChange(order, val)],
            multiple: false,
            placeholder: "请选择执行人员",
            onConfirm: users => handleExecutorConfirm(order, users)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onConfirm"])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "服务开始时间", -1)), _createVNode(_component_el_date_picker, {
            modelValue: order.serviceStart,
            "onUpdate:modelValue": $event => order.serviceStart = $event,
            type: "date",
            format: "YYYY年MM月DD日",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择开始时间",
            class: "w-full form-date",
            onChange: $event => updatePeriodCountByServiceRange(order)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "服务结束时间", -1)), _createVNode(_component_el_date_picker, {
            modelValue: order.serviceEnd,
            "onUpdate:modelValue": $event => order.serviceEnd = $event,
            type: "date",
            format: "YYYY年MM月DD日",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择结束时间",
            class: "w-full form-date",
            onChange: $event => updatePeriodCountByServiceRange(order)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 订单金额 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("div", _hoisted_28, [_cache[30] || (_cache[30] = _createElementVNode("span", {
            class: "absolute left-3 top-2.5 text-slate-500"
          }, "¥", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => order.amount = $event,
            type: "number",
            step: "1",
            class: "form-input form-input-with-prefix w-full",
            placeholder: "0.00"
          }, null, 8, _hoisted_29), [[_vModelText, order.amount, void 0, {
            number: true
          }]])])]), order.orderType === 'PERIODIC' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_cache[32] || (_cache[32] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 分期期数 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => order.periodCount = $event,
            type: "number",
            min: "1",
            step: "1",
            class: "form-input w-full",
            placeholder: "请输入期数",
            onInput: $event => updateServiceEndByPeriodCount(order)
          }, null, 40, _hoisted_31), [[_vModelText, order.periodCount, void 0, {
            number: true
          }]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_32, [_cache[33] || (_cache[33] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "备注", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => order.remark = $event,
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入备注（可选）"
          }, null, 8, _hoisted_33), [[_vModelText, order.remark]])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
          })]), _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "账单明细")], -1)), _createElementVNode("div", _hoisted_36, [_createElementVNode("button", {
            onClick: $event => addBilling(order),
            class: "text-slate-600 text-sm hover:text-slate-800 font-medium px-2 py-1 hover:bg-slate-100 rounded"
          }, " + 手动添加 ", 8, _hoisted_37), _createElementVNode("button", {
            onClick: $event => generateBillings(order),
            class: "text-primary-600 text-sm hover:text-primary-700 font-medium px-2 py-1 hover:bg-primary-50 rounded"
          }, [...(_cache[34] || (_cache[34] = [_createElementVNode("svg", {
            class: "w-4 h-4 inline mr-1",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          })], -1), _createTextVNode(" 自动生成 ", -1)]))], 8, _hoisted_38)])]), order.billings && order.billings.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "flex items-center gap-3 px-3 pb-2 text-xs text-slate-500"
          }, [_createElementVNode("span", {
            class: "w-16"
          }, "期数"), _createElementVNode("span", {
            class: "flex-[1.4] text-left pl-6"
          }, "金额"), _createElementVNode("span", {
            class: "w-24"
          }, "付款日期"), _createElementVNode("span", {
            class: "w-8"
          })], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.billings, (billing, billingIndex) => {
            return _openBlock(), _createElementBlock("div", {
              key: billingIndex,
              class: "flex items-center gap-3 p-3 bg-slate-50 rounded-lg"
            }, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => billing.periodIndex = $event,
              type: "number",
              placeholder: "期次",
              class: "form-input form-control-sm w-16 text-center"
            }, null, 8, _hoisted_40), [[_vModelText, billing.periodIndex, void 0, {
              number: true
            }]]), _createElementVNode("div", _hoisted_41, [_cache[36] || (_cache[36] = _createElementVNode("span", {
              class: "absolute left-2 top-1.5 text-slate-500 text-sm"
            }, "¥", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => billing.amount = $event,
              type: "number",
              step: "0.01",
              class: "form-input form-control-sm form-input-with-prefix w-full",
              placeholder: "0.00",
              onInput: $event => syncOrderAmountFromBillings(order)
            }, null, 40, _hoisted_42), [[_vModelText, billing.amount, void 0, {
              number: true
            }]])]), _createVNode(_component_el_date_picker, {
              modelValue: billing.dueDate,
              "onUpdate:modelValue": $event => billing.dueDate = $event,
              type: "date",
              format: "YYYY年MM月DD日",
              "value-format": "YYYY-MM-DD",
              placeholder: "到期日",
              class: "w-28 form-date form-control-sm"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("button", {
              onClick: $event => removeBilling(order, billingIndex),
              class: "p-1 text-red-500 hover:text-red-700"
            }, [...(_cache[37] || (_cache[37] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_43)]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_44, " 暂无账单，可手动添加或自动生成 ")), _createElementVNode("div", _hoisted_45, [_cache[39] || (_cache[39] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "账单金额合计: ", -1)), _createElementVNode("span", {
            class: _normalizeClass(['font-medium', isBillingTotalValid(order) ? 'text-green-600' : 'text-red-600'])
          }, " ¥" + _toDisplayString(getBillingTotal(order).toLocaleString()), 3), !isBillingTotalValid(order) ? (_openBlock(), _createElementBlock("span", _hoisted_46, "（与订单金额不一致）")) : _createCommentVNode("", true)]), order.productNeedOrderReminder === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("span", _hoisted_49, [_createTextVNode(_toDisplayString(order.orderReminderPrompt || '是否需要服务提醒') + " ", 1), _cache[40] || (_cache[40] = _createElementVNode("span", {
            class: "text-red-500"
          }, "*", -1))]), _createVNode(_component_el_radio_group, {
            modelValue: order.serviceReminderRequired,
            "onUpdate:modelValue": $event => order.serviceReminderRequired = $event
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: 1
            }, {
              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode("是", -1)]))]),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: 0
            }, {
              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createTextVNode("否", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue"])]), order.serviceReminderRequired === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_cache[43] || (_cache[43] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 订单服务提醒 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _cache[44] || (_cache[44] = _createElementVNode("p", {
            class: "mb-2 text-xs text-slate-500"
          }, "该服务产品要求单独设置服务提醒，默认提醒订单创建人、执行人及执行人部门负责人", -1)), _createVNode(OrderServiceRemindersEditor, {
            rows: order.serviceReminders,
            "onUpdate:rows": $event => order.serviceReminders = $event,
            "executor-id": order.executorId,
            locked: true
          }, null, 8, ["rows", "onUpdate:rows", "executor-id"])], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])]);
        }), 128)), _createElementVNode("button", {
          onClick: addOrder,
          class: "w-full py-4 border-2 border-dashed border-slate-300 rounded-xl text-slate-500 hover:border-primary-400 hover:text-primary-600 hover:bg-primary-50 transition-colors flex items-center justify-center gap-2"
        }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 添加订单 ", -1)]))]), _createElementVNode("div", _hoisted_50, [_createElementVNode("span", _hoisted_51, [_cache[46] || (_cache[46] = _createTextVNode("共计 ", -1)), _createElementVNode("span", _hoisted_52, _toDisplayString(planForm.orders.length), 1), _cache[47] || (_cache[47] = _createTextVNode(" 个订单", -1))]), _createElementVNode("div", _hoisted_53, [_cache[48] || (_cache[48] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "方案总金额", -1)), _createElementVNode("span", _hoisted_54, "¥" + _toDisplayString(orderTotalAmount.value.toLocaleString()), 1)])])])])], 512), [[_vShow, currentStep.value === 2]]), _withDirectives(_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_cache[64] || (_cache[64] = _createElementVNode("div", {
          class: "mb-4"
        }, [_createElementVNode("h4", {
          class: "text-base font-medium text-slate-900 mb-1"
        }, "方案跟进提醒"), _createElementVNode("p", {
          class: "text-sm text-slate-500"
        }, "设置方案执行过程中的跟进提醒，可添加多个提醒节点")], -1)), _createElementVNode("div", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planForm.reminders, (reminder, reminderIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: reminder.id || reminder._localKey || reminderIndex,
            class: "border border-slate-200 rounded-xl overflow-hidden"
          }, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_cache[50] || (_cache[50] = _createElementVNode("div", {
            class: "w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 text-amber-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          })])], -1)), _createElementVNode("span", _hoisted_61, "提醒 " + _toDisplayString(reminderIndex + 1), 1), reminder.enabled === false ? (_openBlock(), _createElementBlock("span", _hoisted_62, "已关闭")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_cache[52] || (_cache[52] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "提醒", -1)), _createElementVNode("label", _hoisted_65, [_createElementVNode("input", {
            type: "checkbox",
            class: "form-switch-input",
            checked: reminder.enabled !== false,
            onChange: $event => toggleReminder(reminder)
          }, null, 40, _hoisted_66), _cache[51] || (_cache[51] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1))])]), _createElementVNode("button", {
            onClick: $event => removeReminder(reminderIndex),
            class: "p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
          }, [...(_cache[53] || (_cache[53] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_67)])]), _createElementVNode("div", {
            class: _normalizeClass(["p-4", reminder.enabled === false ? 'opacity-60 pointer-events-none' : ''])
          }, [_createElementVNode("div", _hoisted_68, [_createElementVNode("div", null, [_cache[54] || (_cache[54] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 首次提醒时间 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: reminder.firstReminderTime,
            "onUpdate:modelValue": $event => reminder.firstReminderTime = $event,
            type: "datetime",
            format: "YYYY年MM月DD日 HH:mm",
            "value-format": "YYYY-MM-DDTHH:mm:ss",
            placeholder: "请选择提醒时间",
            class: "w-full form-date",
            disabled: reminder.enabled === false
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]), _createElementVNode("div", null, [_cache[55] || (_cache[55] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 提醒事项 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => reminder.reminderItem = $event,
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入提醒事项",
            disabled: reminder.enabled === false
          }, null, 8, _hoisted_69), [[_vModelText, reminder.reminderItem]])])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("label", {
            class: _normalizeClass(["form-switch", {
              'opacity-60': reminder.enabled === false
            }])
          }, [_createElementVNode("input", {
            type: "checkbox",
            class: "form-switch-input",
            checked: reminder.repeatEnabled,
            disabled: reminder.enabled === false,
            onChange: $event => reminder.repeatEnabled = !reminder.repeatEnabled
          }, null, 40, _hoisted_72), _cache[56] || (_cache[56] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1))], 2), _cache[57] || (_cache[57] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "开启连续提醒", -1))]), reminder.repeatEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_cache[58] || (_cache[58] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "提醒间隔", -1)), _createElementVNode("div", _hoisted_76, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => reminder.repeatIntervalValue = $event,
            type: "number",
            min: "1",
            class: "form-input form-control-sm w-20 text-center",
            placeholder: "1",
            disabled: reminder.enabled === false
          }, null, 8, _hoisted_77), [[_vModelText, reminder.repeatIntervalValue, void 0, {
            number: true
          }]]), _createVNode(_component_el_select, {
            modelValue: reminder.repeatIntervalUnit,
            "onUpdate:modelValue": $event => reminder.repeatIntervalUnit = $event,
            class: "w-24 form-select form-control-sm",
            disabled: reminder.enabled === false
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "天",
              value: "DAY"
            }), _createVNode(_component_el_option, {
              label: "小时",
              value: "HOUR"
            }), _createVNode(_component_el_option, {
              label: "分钟",
              value: "MINUTE"
            })]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_78, [_cache[59] || (_cache[59] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "最大次数", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => reminder.maxReminderCount = $event,
            type: "number",
            min: "1",
            class: "form-input form-control-sm w-20 text-center",
            placeholder: "10",
            disabled: reminder.enabled === false
          }, null, 8, _hoisted_79), [[_vModelText, reminder.maxReminderCount, void 0, {
            number: true
          }]]), _cache[60] || (_cache[60] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "次", -1))])]), _cache[61] || (_cache[61] = _createElementVNode("p", {
            class: "mt-2 text-xs text-slate-500"
          }, "当到指定时间未处理时，将按设置的间隔持续提醒", -1))])) : _createCommentVNode("", true)])], 2)]);
        }), 128))]), _createElementVNode("button", {
          onClick: addReminder,
          class: "w-full py-4 border-2 border-dashed border-slate-300 rounded-xl text-slate-500 hover:border-primary-400 hover:text-primary-600 hover:bg-primary-50 transition-colors flex items-center justify-center gap-2"
        }, [...(_cache[62] || (_cache[62] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 添加提醒 ", -1)]))]), planForm.reminders.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_80, [...(_cache[63] || (_cache[63] = [_createElementVNode("p", {
          class: "text-sm"
        }, "暂无方案跟进提醒", -1), _createElementVNode("p", {
          class: "text-xs mt-1"
        }, "点击上方按钮添加跟进提醒", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_cache[68] || (_cache[68] = _createElementVNode("div", null, [_createElementVNode("h4", {
          class: "text-base font-medium text-slate-900 mb-1"
        }, "方案账单提醒"), _createElementVNode("p", {
          class: "text-sm text-slate-500"
        }, "在账单应收日期前提醒，确保及时收款")], -1)), planForm.billingReminderSetting.id || planForm.billingReminderSetting._added ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_cache[67] || (_cache[67] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "提醒", -1)), _createElementVNode("label", _hoisted_84, [_createElementVNode("input", {
          type: "checkbox",
          class: "form-switch-input",
          checked: planForm.billingReminderSetting?.enabled,
          onChange: toggleBillingReminder
        }, null, 40, _hoisted_85), _cache[65] || (_cache[65] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1))]), _createElementVNode("button", {
          onClick: removeBillingReminder,
          class: "p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
        }, [...(_cache[66] || (_cache[66] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1)]))])])) : (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: addBillingReminder,
          class: "px-3 py-1.5 text-sm text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
        }, " 添加账单提醒 "))]), planForm.billingReminderSetting.id || planForm.billingReminderSetting._added ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_cache[69] || (_cache[69] = _createElementVNode("div", {
          class: "w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-4 h-4 text-green-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
        })])], -1)), _cache[70] || (_cache[70] = _createElementVNode("span", {
          class: "font-medium text-slate-900"
        }, "账单提醒", -1)), !planForm.billingReminderSetting?.enabled ? (_openBlock(), _createElementBlock("span", _hoisted_89, "已关闭")) : _createCommentVNode("", true)])]), _createElementVNode("div", {
          class: _normalizeClass(["p-4", !planForm.billingReminderSetting?.enabled ? 'opacity-60 pointer-events-none' : ''])
        }, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", null, [_cache[72] || (_cache[72] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "提前天数", -1)), _createElementVNode("div", _hoisted_91, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => planForm.billingReminderSetting.advanceDays = $event),
          type: "number",
          min: "0",
          class: "form-input form-control-sm flex-1",
          placeholder: "0",
          disabled: !planForm.billingReminderSetting?.enabled
        }, null, 8, _hoisted_92), [[_vModelText, planForm.billingReminderSetting.advanceDays, void 0, {
          number: true
        }]]), _cache[71] || (_cache[71] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "天", -1))]), _cache[73] || (_cache[73] = _createElementVNode("p", {
          class: "mt-1 text-xs text-slate-500"
        }, "0表示应收日当天", -1))]), _createElementVNode("div", null, [_cache[74] || (_cache[74] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "每日提醒时间", -1)), _createVNode(_component_el_time_picker, {
          modelValue: planForm.billingReminderSetting.remindTime,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => planForm.billingReminderSetting.remindTime = $event),
          format: "HH:mm",
          "value-format": "HH:mm:ss",
          placeholder: "选择时间",
          class: "w-full form-date form-control-sm",
          disabled: !planForm.billingReminderSetting?.enabled
        }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("label", {
          class: _normalizeClass(["form-switch", {
            'opacity-60': !planForm.billingReminderSetting?.enabled
          }])
        }, [_createElementVNode("input", {
          type: "checkbox",
          class: "form-switch-input",
          checked: planForm.billingReminderSetting.repeatEnabled,
          disabled: !planForm.billingReminderSetting?.enabled,
          onChange: _cache[8] || (_cache[8] = $event => planForm.billingReminderSetting.repeatEnabled = !planForm.billingReminderSetting.repeatEnabled)
        }, null, 40, _hoisted_95), _cache[75] || (_cache[75] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1))], 2), _cache[76] || (_cache[76] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-700"
        }, "开启连续提醒", -1))]), planForm.billingReminderSetting.repeatEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_cache[77] || (_cache[77] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "提醒间隔", -1)), _createElementVNode("div", _hoisted_99, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => planForm.billingReminderSetting.repeatIntervalValue = $event),
          type: "number",
          min: "1",
          class: "form-input form-control-sm w-20 text-center",
          placeholder: "1",
          disabled: !planForm.billingReminderSetting?.enabled
        }, null, 8, _hoisted_100), [[_vModelText, planForm.billingReminderSetting.repeatIntervalValue, void 0, {
          number: true
        }]]), _createVNode(_component_el_select, {
          modelValue: planForm.billingReminderSetting.repeatIntervalUnit,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => planForm.billingReminderSetting.repeatIntervalUnit = $event),
          class: "w-24 form-select form-control-sm",
          disabled: !planForm.billingReminderSetting?.enabled
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "天",
            value: "DAY"
          }), _createVNode(_component_el_option, {
            label: "小时",
            value: "HOUR"
          }), _createVNode(_component_el_option, {
            label: "分钟",
            value: "MINUTE"
          })]),
          _: 1
        }, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_101, [_cache[78] || (_cache[78] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "最大次数", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => planForm.billingReminderSetting.maxReminderCount = $event),
          type: "number",
          min: "1",
          class: "form-input form-control-sm w-20 text-center",
          placeholder: "10",
          disabled: !planForm.billingReminderSetting?.enabled
        }, null, 8, _hoisted_102), [[_vModelText, planForm.billingReminderSetting.maxReminderCount, void 0, {
          number: true
        }]]), _cache[79] || (_cache[79] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "次", -1))])])])) : _createCommentVNode("", true)])], 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_103, [...(_cache[80] || (_cache[80] = [_createElementVNode("p", {
          class: "text-sm"
        }, "暂无账单提醒", -1), _createElementVNode("p", {
          class: "text-xs mt-1"
        }, "点击上方按钮添加账单提醒", -1)]))]))]), _createElementVNode("div", null, [_cache[95] || (_cache[95] = _createElementVNode("div", {
          class: "mb-4"
        }, [_createElementVNode("h4", {
          class: "text-base font-medium text-slate-900 mb-1"
        }, "订单续约提醒"), _createElementVNode("p", {
          class: "text-sm text-slate-500"
        }, "在订单服务结束前提醒客户续约，一次性订单和分期订单都可设置")], -1)), planForm.orders.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_104, [...(_cache[81] || (_cache[81] = [_createElementVNode("p", {
          class: "text-sm"
        }, "暂无订单", -1), _createElementVNode("p", {
          class: "text-xs mt-1"
        }, "请先在「订单与账单」中添加订单", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_105, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planForm.orders, (order, orderIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: order.id || order._localKey || orderIndex,
            class: "border border-slate-200 rounded-xl overflow-hidden"
          }, [_createElementVNode("div", _hoisted_106, [_createElementVNode("div", _hoisted_107, [_cache[82] || (_cache[82] = _createElementVNode("div", {
            class: "w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 text-blue-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          })])], -1)), _createElementVNode("span", _hoisted_108, _toDisplayString(order.productNameSnapshot || '订单 ' + (orderIndex + 1)), 1), order.orderType === 'ONCE' ? (_openBlock(), _createElementBlock("span", _hoisted_109, "一次性")) : (_openBlock(), _createElementBlock("span", _hoisted_110, "分期"))]), order.renewalReminderSetting?.id || order.renewalReminderSetting?._added ? (_openBlock(), _createElementBlock("div", _hoisted_111, [_cache[85] || (_cache[85] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "提醒", -1)), _createElementVNode("label", _hoisted_112, [_createElementVNode("input", {
            type: "checkbox",
            class: "form-switch-input",
            checked: order.renewalReminderSetting?.enabled,
            onChange: $event => toggleOrderRenewalReminder(order)
          }, null, 40, _hoisted_113), _cache[83] || (_cache[83] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1))]), _createElementVNode("button", {
            onClick: $event => removeOrderRenewalReminder(order),
            class: "p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
          }, [...(_cache[84] || (_cache[84] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_114)])) : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => addOrderRenewalReminder(order),
            class: "px-3 py-1.5 text-sm text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
          }, " 添加续约提醒 ", 8, _hoisted_115))]), order.renewalReminderSetting?.id || order.renewalReminderSetting?._added ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["p-4", !order.renewalReminderSetting?.enabled ? 'opacity-60 pointer-events-none' : ''])
          }, [_createElementVNode("div", _hoisted_116, [_createElementVNode("div", null, [_cache[87] || (_cache[87] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "提前天数", -1)), _createElementVNode("div", _hoisted_117, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => order.renewalReminderSetting.advanceDays = $event,
            type: "number",
            min: "0",
            class: "form-input form-control-sm flex-1",
            placeholder: "0",
            disabled: !order.renewalReminderSetting?.enabled
          }, null, 8, _hoisted_118), [[_vModelText, order.renewalReminderSetting.advanceDays, void 0, {
            number: true
          }]]), _cache[86] || (_cache[86] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "天", -1))]), _cache[88] || (_cache[88] = _createElementVNode("p", {
            class: "mt-1 text-xs text-slate-500"
          }, "0表示服务结束当天", -1))]), _createElementVNode("div", null, [_cache[89] || (_cache[89] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "每日提醒时间", -1)), _createVNode(_component_el_time_picker, {
            modelValue: order.renewalReminderSetting.remindTime,
            "onUpdate:modelValue": $event => order.renewalReminderSetting.remindTime = $event,
            format: "HH:mm",
            "value-format": "HH:mm:ss",
            placeholder: "选择时间",
            class: "w-full form-date form-control-sm",
            disabled: !order.renewalReminderSetting?.enabled
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, [_createElementVNode("label", {
            class: _normalizeClass(["form-switch", {
              'opacity-60': !order.renewalReminderSetting?.enabled
            }])
          }, [_createElementVNode("input", {
            type: "checkbox",
            class: "form-switch-input",
            checked: order.renewalReminderSetting.repeatEnabled,
            disabled: !order.renewalReminderSetting?.enabled,
            onChange: $event => order.renewalReminderSetting.repeatEnabled = !order.renewalReminderSetting.repeatEnabled
          }, null, 40, _hoisted_121), _cache[90] || (_cache[90] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1))], 2), _cache[91] || (_cache[91] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "开启连续提醒", -1))]), order.renewalReminderSetting.repeatEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, [_createElementVNode("div", _hoisted_124, [_cache[92] || (_cache[92] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "提醒间隔", -1)), _createElementVNode("div", _hoisted_125, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => order.renewalReminderSetting.repeatIntervalValue = $event,
            type: "number",
            min: "1",
            class: "form-input form-control-sm w-20 text-center",
            placeholder: "1",
            disabled: !order.renewalReminderSetting?.enabled
          }, null, 8, _hoisted_126), [[_vModelText, order.renewalReminderSetting.repeatIntervalValue, void 0, {
            number: true
          }]]), _createVNode(_component_el_select, {
            modelValue: order.renewalReminderSetting.repeatIntervalUnit,
            "onUpdate:modelValue": $event => order.renewalReminderSetting.repeatIntervalUnit = $event,
            class: "w-24 form-select form-control-sm",
            disabled: !order.renewalReminderSetting?.enabled
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "天",
              value: "DAY"
            }), _createVNode(_component_el_option, {
              label: "小时",
              value: "HOUR"
            }), _createVNode(_component_el_option, {
              label: "分钟",
              value: "MINUTE"
            })]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_127, [_cache[93] || (_cache[93] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "最大次数", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => order.renewalReminderSetting.maxReminderCount = $event,
            type: "number",
            min: "1",
            class: "form-input form-control-sm w-20 text-center",
            placeholder: "10",
            disabled: !order.renewalReminderSetting?.enabled
          }, null, 8, _hoisted_128), [[_vModelText, order.renewalReminderSetting.maxReminderCount, void 0, {
            number: true
          }]]), _cache[94] || (_cache[94] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "次", -1))])])])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true)]);
        }), 128))]))])])], 512), [[_vShow, currentStep.value === 3]]), _withDirectives(_createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, [_cache[107] || (_cache[107] = _createElementVNode("div", {
          class: "mb-6"
        }, [_createElementVNode("h4", {
          class: "text-base font-medium text-slate-900 mb-1"
        }, "确认方案信息"), _createElementVNode("p", {
          class: "text-sm text-slate-500"
        }, "请仔细核对以下信息，确认无误后提交")], -1)), _createElementVNode("div", _hoisted_131, [_cache[100] || (_cache[100] = _createElementVNode("div", {
          class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center gap-2"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })]), _createElementVNode("span", {
          class: "font-medium text-slate-900"
        }, "方案信息")], -1)), _createElementVNode("div", _hoisted_132, [_createElementVNode("div", _hoisted_133, [_createElementVNode("div", null, [_cache[96] || (_cache[96] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "方案名称", -1)), _createElementVNode("div", _hoisted_134, _toDisplayString(planForm.name || '-'), 1)]), _createElementVNode("div", null, [_cache[97] || (_cache[97] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "客户", -1)), _createElementVNode("div", _hoisted_135, _toDisplayString(selectedCustomerName.value || '-'), 1)]), _createElementVNode("div", _hoisted_136, [_cache[98] || (_cache[98] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "方案详情", -1)), _withDirectives(_createElementVNode("div", _hoisted_137, null, 512), [[_directive_safe_html, planForm.detailContent || '-']])]), _createElementVNode("div", _hoisted_138, [_cache[99] || (_cache[99] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "备注", -1)), _createElementVNode("div", _hoisted_139, _toDisplayString(planForm.remark || '-'), 1)])])])]), _createElementVNode("div", _hoisted_140, [_createElementVNode("div", _hoisted_141, [_cache[101] || (_cache[101] = _createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        })]), _createElementVNode("span", {
          class: "font-medium text-slate-900"
        }, "订单明细")], -1)), _createElementVNode("span", _hoisted_142, "共 " + _toDisplayString(planForm.orders.length) + " 个订单", 1)]), _createElementVNode("div", _hoisted_143, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planForm.orders, (order, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "p-4"
          }, [_createElementVNode("div", _hoisted_144, [_createElementVNode("div", _hoisted_145, [_createElementVNode("span", _hoisted_146, "订单 " + _toDisplayString(index + 1), 1), _createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-medium', order.orderType === 'ONCE' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'])
          }, _toDisplayString(order.orderType === 'ONCE' ? '一次性服务' : `分期服务（${order.periodCount || 0}期）`), 3)]), _createElementVNode("span", _hoisted_147, "¥" + _toDisplayString(order.amount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_148, [_createElementVNode("div", null, [_cache[102] || (_cache[102] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "产品：", -1)), _createElementVNode("span", _hoisted_149, _toDisplayString(getProductName(order.productId)), 1)]), _createElementVNode("div", null, [_cache[103] || (_cache[103] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "执行人员：", -1)), _createElementVNode("span", _hoisted_150, _toDisplayString(getExecutorName(order)), 1)]), _createElementVNode("div", null, [_cache[104] || (_cache[104] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "服务周期：", -1)), _createElementVNode("span", _hoisted_151, _toDisplayString(order.serviceStart || '-') + " ~ " + _toDisplayString(order.serviceEnd || '-'), 1)]), _createElementVNode("div", null, [_cache[105] || (_cache[105] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "账单数：", -1)), _createElementVNode("span", _hoisted_152, _toDisplayString(order.billings?.length || 0) + " 笔", 1)])])]);
        }), 128))]), _createElementVNode("div", _hoisted_153, [_cache[106] || (_cache[106] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "方案总金额", -1)), _createElementVNode("span", _hoisted_154, "¥" + _toDisplayString(orderTotalAmount.value.toLocaleString()), 1)])]), _cache[108] || (_cache[108] = _createElementVNode("div", {
          class: "bg-amber-50 border border-amber-200 rounded-lg p-4"
        }, [_createElementVNode("div", {
          class: "flex items-start gap-2"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-amber-500 mt-0.5",
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [_createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
          "clip-rule": "evenodd"
        })]), _createElementVNode("div", {
          class: "text-sm text-amber-700"
        }, [_createElementVNode("p", {
          class: "font-medium"
        }, "温馨提示"), _createElementVNode("p", {
          class: "mt-1"
        }, "请确保所有信息准确无误后再提交。提交后将进入审批流程（如果需要）。")])])], -1))])], 512), [[_vShow, currentStep.value === 4]])]), _createElementVNode("div", _hoisted_155, [currentStep.value > 1 ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: prevStep,
          class: "btn-secondary"
        }, " 上一步 ")) : (_openBlock(), _createElementBlock("div", _hoisted_156)), _createElementVNode("div", _hoisted_157, [_createElementVNode("button", {
          onClick: closeModal,
          class: "btn-secondary"
        }, " 取消 "), currentStep.value < 4 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!isEditingFormalPlan.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: handleSaveDraft,
          loading: saving.value,
          class: "btn-secondary"
        }, " 暂存 ", 8, _hoisted_158)) : _createCommentVNode("", true), _createElementVNode("button", {
          onClick: nextStep,
          class: "btn-primary inline-flex items-center gap-2"
        }, [...(_cache[109] || (_cache[109] = [_createTextVNode(" 下一步 ", -1), _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1)]))])], 64)) : (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: handleSubmit,
          loading: saving.value,
          class: "btn-primary"
        }, " 提交方案 ", 8, _hoisted_159))])])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};